<div class="page-container" [class.loading]="isLoading">
    <div class="app-grid" *ngIf="email">
        <div class="columns-12">
            <div class="app-grid">
                <div class="columns-11">
                    <app-header class="title" [back]="true" [noTitle]="true"> </app-header>
                </div>
                <div class="columns-1" *ngIf="email.status == 'permanent_fail' && !hasResentEmail">
                    <ui-button class="margin-bottom-5" (click)="resendMessage()" type="primary">{{
                        'resend' | translate
                    }}</ui-button>
                </div>
            </div>
        </div>
        <div *ngIf="email.status == 'permanent_fail' && !hasResentEmail" class="columns-12 margin-bottom-3">
            <ui-banner variant="danger">
                <p>{{ 'applicant-tracker.thisEmailFailedToSendToThisRecipient' | translate }}</p>
            </ui-banner>
        </div>
        <div *ngIf="email.status == 'temporary_fail'" class="columns-12 margin-bottom-3">
            <ui-banner variant="danger">
                <p>{{ 'applicant-tracker.thisEmailFailedToSend' | translate }}</p>
            </ui-banner>
        </div>
        <div class="columns-12">
            <ui-card>
                <div class="subject margin-bottom-3">
                    {{ email.subject }}
                    <div class="date">{{ email.createdAt | date: 'medium' }}</div>
                </div>

                <div class="app-grid">
                    <div class="columns-1 recruiter-avatar">
                        <app-avatar [employee]="email.sender" size="inline"></app-avatar>
                    </div>

                    <div class="columns-11">
                        <div class="margin-bottom-4">
                            <div class="from margin-bottom-2">
                                {{ email.sender?.fullName }}
                                <span class="email padding-left-4"> <{{ email.replyTo }}> </span>
                            </div>
                            <div class="to">
                                {{ 'to' | translate }} {{ applicant?.fullName }}
                                <span class="email padding-left-4"> <{{ email.emailSentTo }}> </span>
                            </div>
                        </div>

                        <div class="app-grid message">
                            <div [innerHtml]="email.body | sanitizeHtml"></div>
                        </div>
                    </div>
                </div>
            </ui-card>
        </div>
    </div>
</div>
